module.exports = __webpack_public_path__ + "static/img/cp-logo.bc088fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/cp-logo.jpg
// module id = 98yG
// module chunks = 1